import { render, staticRenderFns } from "./addHokp.vue?vue&type=template&id=4141cb66"
import script from "./addHokp.vue?vue&type=script&lang=js"
export * from "./addHokp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports